import { ToastService } from "@shared/lib/services";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_DYNAMIC_FACETS_QUERY_KEY } from "../contsants";
import { CampaignService } from "../services/Campaign.service";

export function useGetDynamicFacets(briefId: string) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...BRIEF_DYNAMIC_FACETS_QUERY_KEY(briefId)],
    queryFn: () => CampaignService.getBriefDynamicFacets(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    dynamicFacets: data?.data,
    isLoading,
    isError,
  };
}
